export function mapDepartmentWorkloadRows(rows) {
    return (rows ?? [])
        .filter((row) => (row.caseCount ?? 0) > 0)
        .map((row) => ({
        name: row.name?.trim() || '—',
        count: row.caseCount ?? 0,
    }));
}
export function mapAgentWorkloadRows(rows) {
    return (rows ?? [])
        .filter((row) => (row.caseCount ?? 0) > 0)
        .map((row) => ({
        name: row.name?.trim() || row.username?.trim() || '—',
        count: row.caseCount ?? 0,
    }));
}
export const departmentRoleOptions = [
    { role: 'LEAD_DEPARTMENT', label: 'Lead Department (Primary responsibility)' },
    { role: 'SUPPORT_DEPARTMENT', label: 'Support Department (Assistance)' },
];
export const agentRoleOptions = [
    { role: 'LEAD_AGENT', label: 'Lead Agent (Primary responsible agent for the case)' },
    { role: 'SUPPORT_AGENT', label: 'Support Agent (Supporting agent providing assistance)' },
    { role: 'REVIEWER', label: 'Reviewer (Reviews and approves case resolution)' },
    { role: 'OBSERVER', label: 'Observer (Can view case updates but not modify)' },
    { role: 'CONSULTANT', label: 'Consultant (Provides expert consultation when needed)' },
];
export function roleOptionsForAssignment(row) {
    if (row.assignedDepartment) {
        return departmentRoleOptions;
    }
    return agentRoleOptions;
}
/** Display label for an assignment row (agent name or department name). */
export function assignmentAssigneeLabel(row, fallback = '—') {
    return row.assignedUser?.name ?? row.assignedDepartment?.name ?? fallback;
}
